import http from '@/utils/http'
// 生成编码
export const systemTextCode = (data: any) => http.post('/system/text/code', data)
